import { getFiGrowthBook } from '../../lib/growthbook';
import { showNanoVariant } from '../NanoBanner/NanoBanner';
import { showRescueGwaVariant } from '../../views/RescueLanding/RescueBanner';

export const HIDE_SIX_MONTH_PLAN_FLAG = 'ecom-hide-six-month-plan-test';

/**
 * Pricing experiment: hide the 6-month prepaid plan on D2C PDP choosers to
 * baseline how removing it impacts sales. Guards run before flag evaluation
 * so excluded surfaces never fire an exposure event:
 * - The nano/rescue simplified variants restrict the Mini chooser to the
 *   6-month plan only (and nano preselects 6-month on S3+) - hiding it would
 *   empty the chooser, so those variants opt out entirely.
 * - If removing the 6-month plan changes nothing (no 6-month plan present) or
 *   removes everything (redemption pages pass a 6-month-only list), return
 *   the list untouched.
 */
export function filterSixMonthPlanForExperiment<T extends { renewalMonths: number }>(products: T[]): T[] {
  if (showNanoVariant() || showRescueGwaVariant()) {
    return products;
  }
  const withoutSixMonth = products.filter((p) => p.renewalMonths !== 6);
  if (withoutSixMonth.length === products.length || withoutSixMonth.length === 0) {
    return products;
  }
  return getFiGrowthBook().getFeatureValue(HIDE_SIX_MONTH_PLAN_FLAG, false) ? withoutSixMonth : products;
}
